export const saveStatusReducer = (currentSaveStatus, action) => {
  const { lastSavedQuestions, saveFailedQuestions, savingBlocks } = currentSaveStatus;
  const newSaveStatus = { ...currentSaveStatus };

  switch (action.type) {
  case 'ADD_SAVING_BLOCK':
    if (savingBlocks.indexOf(action.block) === -1) {
      return { ...currentSaveStatus, savingBlocks: [...savingBlocks, action.block] };
    }
    return currentSaveStatus;
  case 'SET_SAVED_RESULT': {
    if(action.result) {
      if (lastSavedQuestions.indexOf(action.datasheetQuestionId) === -1) {
        newSaveStatus.lastSavedQuestions = [...lastSavedQuestions, action.datasheetQuestionId];
      }
      if (saveFailedQuestions.indexOf(action.datasheetQuestionId) !== -1) {
        const newSaveFailedQuestions = [...saveFailedQuestions];
        newSaveFailedQuestions.splice(newSaveFailedQuestions.indexOf(action.datasheetQuestionId), 1);
        newSaveStatus.saveFailedQuestions = newSaveFailedQuestions;
      }
    } else if (saveFailedQuestions.indexOf(action.datasheetQuestionId) === -1) {
      newSaveStatus.saveFailedQuestions = [...saveFailedQuestions, action.datasheetQuestionId];
    }
    newSaveStatus.retrying = false;
    return newSaveStatus;
  }
  case 'REMOVE_LAST_SAVED_QUESTION':
    if (lastSavedQuestions.indexOf(action.datasheetQuestionId) !== -1) {
      const newLastSavedQuestions = [...lastSavedQuestions];
      newSaveStatus.removedSavedQuestionId = action.datasheetQuestionId;
      newLastSavedQuestions.splice(newLastSavedQuestions.indexOf(action.datasheetQuestionId), 1);
      newSaveStatus.lastSavedQuestions = newLastSavedQuestions;
    }
    return newSaveStatus;
  case 'CLEAR_LAST_SAVED_QUESTION':
    newSaveStatus.lastSavedQuestions = [];
    return newSaveStatus;
  case 'RETRY_AUTO_SAVE':
    return { ...currentSaveStatus, retrying: true };
  default:
    throw new Error(`Unknown saveErrorReducer action type: ${action.type}`);
  }
};
